// source: user.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pathway_pb = require('./pathway_pb.js');
goog.object.extend(proto, pathway_pb);
goog.exportSymbol('proto.itp.User', null, global);
goog.exportSymbol('proto.itp.User.Grade', null, global);
goog.exportSymbol('proto.itp.User.Type', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.itp.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.itp.User.repeatedFields_, null);
};
goog.inherits(proto.itp.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.itp.User.displayName = 'proto.itp.User';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.itp.User.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.itp.User.prototype.toObject = function(opt_includeInstance) {
  return proto.itp.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.itp.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.itp.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    grade: jspb.Message.getFieldWithDefault(msg, 5, 0),
    county: jspb.Message.getFieldWithDefault(msg, 6, ""),
    pathwaysList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    school: jspb.Message.getFieldWithDefault(msg, 8, ""),
    leaderboardName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    accountType: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.itp.User}
 */
proto.itp.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.itp.User;
  return proto.itp.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.itp.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.itp.User}
 */
proto.itp.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {!proto.itp.User.Grade} */ (reader.readEnum());
      msg.setGrade(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCounty(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.itp.Pathways>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPathways(values[i]);
      }
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchool(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeaderboardName(value);
      break;
    case 10:
      var value = /** @type {!proto.itp.User.Type} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.itp.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.itp.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.itp.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.itp.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGrade();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCounty();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPathwaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getSchool();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLeaderboardName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.itp.User.Grade = {
  SEVENTH: 0,
  EIGHTH: 1,
  NINTH: 2,
  TENTH: 3,
  ELEVENTH: 4,
  TWELFTH: 5
};

/**
 * @enum {number}
 */
proto.itp.User.Type = {
  STUDENT: 0,
  PARENT: 1,
  TEACHER: 2,
  CITIZEN: 3,
  ADMIN: 4
};

/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.itp.User.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.itp.User.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.itp.User.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.itp.User.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional Grade grade = 5;
 * @return {!proto.itp.User.Grade}
 */
proto.itp.User.prototype.getGrade = function() {
  return /** @type {!proto.itp.User.Grade} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.itp.User.Grade} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setGrade = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string county = 6;
 * @return {string}
 */
proto.itp.User.prototype.getCounty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setCounty = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated Pathways pathways = 7;
 * @return {!Array<!proto.itp.Pathways>}
 */
proto.itp.User.prototype.getPathwaysList = function() {
  return /** @type {!Array<!proto.itp.Pathways>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.itp.Pathways>} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setPathwaysList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.itp.Pathways} value
 * @param {number=} opt_index
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.addPathways = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.clearPathwaysList = function() {
  return this.setPathwaysList([]);
};


/**
 * optional string school = 8;
 * @return {string}
 */
proto.itp.User.prototype.getSchool = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setSchool = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string leaderboard_name = 9;
 * @return {string}
 */
proto.itp.User.prototype.getLeaderboardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setLeaderboardName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional Type account_type = 10;
 * @return {!proto.itp.User.Type}
 */
proto.itp.User.prototype.getAccountType = function() {
  return /** @type {!proto.itp.User.Type} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.itp.User.Type} value
 * @return {!proto.itp.User} returns this
 */
proto.itp.User.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


goog.object.extend(exports, proto.itp);
